import React from 'react';
import { CustomTextField } from '../../../../widgets/CustomTextField';
import { EntityForm } from '../../../../widgets/Forms';
import ViewUtils from '../../../../ViewUtils';
import TabPanel from '../../../../widgets/TabPanel';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const utils = new ViewUtils();

const styles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            minWidth: 50,
            textAlign: 'center',
        },
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        minWidth: 200
    },
    inputForm: {
        minWidth: '200px',
    },
    table: {
        minWidth: 700,
    },
    inputCenter: {
        textAlign: 'center'
    },
    paper: {
        position: "absolute",
        width: 600,
        height: 450,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(0.1)
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#01579B',
        color: theme.palette.common.white,
        border: '1px solid white',
        height: 6
    },
    body: {
        fontSize: 11,
    },

}))(TableCell);

const StyledTableTextCell = withStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            // width: 50,
            textAlign: 'center'
        },
    },
    body: {
        fontSize: 14,
        fontWeight: 500
    }

}))(TableCell);


const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
            height: theme.palette.action.main
        },
    },
}))(TableRow);

const useStyles = theme => ({
    table: {
        minWidth: 700,
    },
});

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 5;
    const left = 5;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`
    };
}

export const ImpactAssessmentForm = React.forwardRef((props, ref) => {
    const [tabValue, setTabValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <EntityForm
            ref={ref}
            viewId={null}
            values={props.data}
            entityLookupController={props.entityLookupController}
            org="saseta"
            entityLookupId={props.id}
            useCustomSettings={false}
            dataArrivedHandler={props.dataArrivedHandler} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="ImpactAssessment">
                    <div className="row w-100">
                        <div className="col w-100">
                            <TabPanel value={tabValue} index={0} className=''>
                                <Table className={styles.table} size="small" >
                                    <TableHead>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <td>
                                                <CustomTextField
                                                    id="Impact"
                                                    key={tabValue}
                                                    label="Has the Impact of the Training Interventions been Measured? If Yes, what Methodology has been used and what was the Impact?"
                                                    className="w-100"
                                                    required

                                                    form={form}
                                                />
                                            </td>
                                        </TableRow>
                                        <TableRow>
                                            <td>
                                                <CustomTextField
                                                    id="AffectedCompany"
                                                    key={tabValue}
                                                    label="Indicate how Training as Reported in the ATR, and PTR has Affected the Company"
                                                    className="w-100"
                                                    required

                                                    form={form}
                                                />
                                            </td>
                                        </TableRow>
                                        <TableRow>
                                            <td>
                                                <CustomTextField
                                                    id="Suggestions"
                                                    key={tabValue}
                                                    label="Do you have any Suggestion on how the WSP/ATR Format can be Improved (Given the Stipulated Minimum Requirements from the Department)?"
                                                    className="w-100"
                                                    required

                                                    form={form}
                                                />
                                            </td>
                                        </TableRow>
                                        <TableRow>
                                            <td>
                                                <CustomTextField
                                                    id="Challenges"
                                                    key={tabValue}
                                                    label="List the top 3 challenges encountered working with the SETA in the current financial year?"
                                                    className="w-100"
                                                    required

                                                    form={form}
                                                />
                                            </td>
                                        </TableRow>
                                        <TableRow>
                                            <td>
                                                <CustomTextField
                                                    id="PercBeneficiaries"
                                                    key={tabValue}
                                                    label="How many SETA Funded beneficiaries were trained and absorbed?"
                                                    className="w-100"
                                                    required

                                                    form={form}
                                                />
                                            </td>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TabPanel>
                        </div>
                    </div>
                </form >
            }
        </EntityForm >
    );
})